import type { SlcpAnalyticsResponse } from '@/api/(admin)/slcp-analytics/types';
import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

/**
 * Pure RPC for the SLCP adoption dashboard — `GET /api/admin/slcp/analytics`.
 * The date bounds are built in the hook and arrive as a query string; the
 * payload comes under the standard `{ data }` envelope and is unwrapped here.
 */
export async function fetchSlcpAnalytics(
  qs: string,
): Promise<SlcpAnalyticsResponse> {
  const { data } = await apiFetch<{ data: SlcpAnalyticsResponse }>(
    qs ? `/api/admin/slcp/analytics?${qs}` : '/api/admin/slcp/analytics',
    {},
    API_ROOT_URL,
  );
  return data;
}
